import { render, staticRenderFns } from "./model-edit-supplier.vue?vue&type=template&id=6b23a43a&scoped=true&"
import script from "./model-edit-supplier.vue?vue&type=script&lang=js&"
export * from "./model-edit-supplier.vue?vue&type=script&lang=js&"
import style0 from "./model-edit-supplier.vue?vue&type=style&index=0&id=6b23a43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23a43a",
  null
  
)

export default component.exports